import { mapState } from 'vuex'

/**
 * 行程收集公共逻辑
 * 保存接口只提交本次发生变更的字段；需求字段为 2（后台设置不安排）时由调用方负责不提交。
 */
export default {
  computed: {
    ...mapState('user', ['guestId'])
  },
  methods: {
    /**
     * @param {Object} payload 本次变更的字段
     * @param {String} toastText 保存成功后的 Toast 文案，不传则不提示
     * @returns {Promise<Boolean>} 是否保存成功
     */
    saveItinerary (payload, toastText) {
      const params = {}
      Object.keys(payload || {}).forEach(key => {
        const value = payload[key]
        // 未发生变化的字段（空值）不提交
        if (value === undefined || value === null || value === '') return
        params[key] = value
      })
      if (!Object.keys(params).length) return Promise.resolve(false)

      const guestId = this.guestId || localStorage.getItem('guestId') || ''
      if (guestId) params.guestId = guestId

      this.$showLoading()
      return this.$Req('common/saveItinerary', params)
        .then(() => {
          if (toastText) this.$toast(toastText)
          // 保存成功后重新拉取页面数据，保证执行状态等回显最新
          this.$emit('refresh')
          // 有刷新逻辑时由父级在数据回来后关闭 loading，避免刷新期间闪烁
          if (!(this.$listeners && this.$listeners.refresh)) this.$hideLoading()
          return true
        })
        .catch(() => {
          this.$hideLoading()
          return false
        })
    }
  }
}
